import { create } from 'zustand';
import { Integration } from '../services/integrations.service';

interface IntegrationsState {
  integrations: Integration[];
  setIntegrations: (integrations: Integration[]) => void;
  addIntegration: (integration: Integration) => void;
  updateIntegration: (integration: Integration) => void;
  removeIntegration: (id: string) => void;
  getById: (id: string) => Integration | undefined;
  getByType: (type: Integration['type']) => Integration[];
}

export const useIntegrationsStore = create<IntegrationsState>((set, get) => ({
  integrations: [],
  setIntegrations: (integrations) => set({ integrations }),
  addIntegration: (integration) =>
    set((state) => ({ integrations: [...state.integrations, integration] })),
  updateIntegration: (integration) =>
    set((state) => ({
      integrations: state.integrations.map((i) =>
        i.id === integration.id ? integration : i,
      ),
    })),
  removeIntegration: (id) =>
    set((state) => ({
      integrations: state.integrations.filter((i) => i.id !== id),
    })),
  getById: (id) => get().integrations.find((i) => i.id === id),
  getByType: (type) => get().integrations.filter((i) => i.type === type),
}));
